module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36.992 33.813\"><defs><style>.a{fill:none;stroke:#1e1e6b;stroke-width:3px;}</style></defs><path class=\"a\" d=\"M-9988.408,3284.656l16.191-22.79,16.736,24.485h-27.5l10.766-15.458,14.71,20.662h-27.548\" transform=\"translate(-9952.639 3293.055) rotate(180)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/components/svgs/gr_logo.svg
// module id = LcXx
// module chunks = 1